export const formatTimePassed = (dateString, translate) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);
    const diffInDays = Math.floor(diffInHours / 24);

    const timeString = date.toLocaleTimeString('pl-PL', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });

    if (diffInHours < 24) {
        const hours = Math.floor(diffInHours);
        const minutes = Math.floor((diffInHours % 1) * 60);
        return `${hours}h ${minutes}m ${translate('notification.timeAgo')}`;
    } else if (diffInDays === 1) {
        return `${translate('resources.device.fields.yesterday')}, ${timeString}`;
    } else {
        return `${diffInDays} ${translate('resources.device.fields.daysAgo')}, ${timeString}`;
    }
};

export const formatTimePassedExpanded = (dateString, translate) => {
    const date = new Date(dateString);
    const now = new Date();

    const dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const nowStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffInDays = Math.floor((nowStart - dateStart) / (1000 * 60 * 60 * 24));

    const timeString = date.toLocaleTimeString('pl-PL', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });

    if (diffInDays === 0) {
        return translate('resources.serviceRequest.time.today', { time: timeString });
    } else if (diffInDays === 1) {
        return translate('resources.serviceRequest.time.yesterday', { time: timeString });
    } else if (diffInDays === 2) {
        return translate('resources.serviceRequest.time.2daysAgo', { time: timeString });
    } else {
        const dateString = date.toLocaleDateString('pl-PL', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        return `${dateString}, ${timeString}`;
    }
};
